





















import Vue from 'vue'

export default Vue.extend({
	props: ["params"],
	computed: {
		isTotalRow(this: any): boolean {
			return this.params?.node?.rowPinned === 'bottom'
        && this.params?.data?.isTotalRow === true
		},
		displayTotal(this: any): string {
			return this.params?.data?.displayTotalDoPedido || ''
		},
	},
})
